import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuth, initializeUserSession } from 'src/redux/thunks/authThunks';
import { isTenantDomain } from 'src/utils/domainContext';
import SplashScreen from 'src/components/loading-screen/splash-screen'; // Optional

export default function GuestGuard({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { isAuthenticated, isInitialized, isSessionLoaded, sites } = useSelector((state) => state.auth);

  // Trigger checkAuth and initializeUserSession only once
  useEffect(() => {
    if (!isInitialized) {
      dispatch(checkAuth());
      dispatch(initializeUserSession());
    }
  }, [dispatch, isInitialized]);

  // Optional: you can show a splash screen while checking auth
  if (!isInitialized || !isSessionLoaded) {
    return <SplashScreen />; // or return null
  }

  // Only redirect to dashboard if truly authenticated AND
  // (on a tenant domain) the user has sites for this tenant
  if (isAuthenticated) {
    if (isTenantDomain() && (!sites || sites.length === 0)) {
      // User is authenticated via cookie but doesn't belong to this tenant.
      // Let them stay on the login page so they can log in with proper credentials.
      return children;
    }

    const selectedSite = JSON.parse(localStorage.getItem('selectedSubscrSite') || '{}');
    const availableRoles = JSON.parse(localStorage.getItem('availableRoles') || '[]');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isVendor = Boolean(
      (user?.vendorId != null && user?.vendorId !== '' && user?.vendorId !== 'null' && user?.vendorId !== undefined) ||
      (selectedSite?.roleName && String(selectedSite.roleName).toLowerCase().includes('vendor')) ||
      (Array.isArray(availableRoles) && availableRoles.some((r) => String(r?.roleName).toLowerCase().includes('vendor'))) ||
      (user?.role && String(user.role).toLowerCase().includes('vendor')) ||
      (Array.isArray(user?.roles) && user.roles.some((r) => String(r).toLowerCase().includes('vendor')))
    );

    const defaultPath = isVendor ? '/dashboard/vendorPortal/requisitions' : '/dashboard';
    let redirectPath = location.state?.from?.pathname || defaultPath;
    if (isVendor && (redirectPath === '/dashboard' || redirectPath === '/dashboard/')) {
      redirectPath = '/dashboard/vendorPortal/requisitions';
    }

    return <Navigate to={redirectPath} replace />;
  }

  return children;
}

GuestGuard.propTypes = {
  children: PropTypes.node,
};
